(() => {
  if (window.CPRMobilePanels) return;
  window.CPRMobilePanels = true;
  const mobile = matchMedia('(max-width:1023.98px)');
  let form, panel, opener, snapshot, previousOverflow, forwarding = false;
  const inputs = f => [...f.querySelectorAll('input')];
  const style = document.createElement('style');
  style.textContent = `
    .cpr-selection-summary,.cpr-selection-footer,.cpr-selection-count{display:none}
    @media(max-width:1023.98px){
      .cpr-panel-open.cc-filters{padding-bottom:110px!important;height:100dvh!important;box-sizing:border-box;overflow-y:auto!important}
      .cpr-panel-open .cpr-selection-summary{display:block;padding:12px 18px;border-bottom:1px solid #e7eded}
      .cpr-selection-chips{display:flex;flex-wrap:wrap;gap:7px}
      .cpr-selection-chips button{display:inline-flex;align-items:center;gap:9px;max-width:100%;white-space:normal;padding:7px 10px;border:1px solid #cde1e3;border-radius:18px;background:#edf7f7;color:#19434a;font:inherit;font-size:12px;text-align:left}
      .cpr-selection-empty{margin:0;color:#687b80;font-size:13px}
      .cpr-panel-open .cpr-selection-count{display:inline;margin-left:5px;color:#00858d}
      .cpr-panel-open .cpr-selection-footer{display:flex!important;flex-direction:column;gap:8px;position:fixed;bottom:0;left:0;right:0;z-index:10;padding:12px 18px calc(12px + env(safe-area-inset-bottom));background:#fff;border-top:1px solid #e7eded}
      .cpr-selection-footer .cpr-mobile-apply{display:block!important;width:100%;min-height:46px;border:0;border-radius:24px;background:#522b88;color:#fff;font:inherit;font-weight:700}
      .cpr-selection-footer .cpr-selection-clear{background:none;border:0;color:#52676d;text-decoration:underline;font:inherit;font-size:12px;padding:2px}
      .cpr-panel-open .cpr-selection-footer [hidden]{display:none!important}
      .cpr-mobile-panel-open .cc-filters__footer{display:none!important}
    }`;
  document.head.appendChild(style);

  function selected() {
    if (!panel) return [];
    return inputs(panel).filter(el => !el.disabled && el.name.startsWith('filter.') &&
      (el.type === 'checkbox' || el.type === 'radio' ? el.checked : el.value.trim() !== ''));
  }
  function labelFor(el) {
    const label = [...(el.labels || [])][0];
    const text = label?.querySelector('.cc-filter-label')?.textContent || label?.textContent;
    if (el.type === 'checkbox' || el.type === 'radio') return (text || el.value).trim();
    return `${el.name.endsWith('.gte') ? 'Min. prijs' : 'Max. prijs'}: ${el.value}`;
  }
  function render() {
    if (!panel || panel.matches('.cc-filter--sort')) return;
    const selection = selected();
    const chips = panel.querySelector('.cpr-selection-chips');
    chips.replaceChildren();
    selection.forEach(el => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = labelFor(el) + ' ×';
      button.setAttribute('aria-label', labelFor(el) + ' verwijderen');
      button.addEventListener('click', () => {
        if (el.type === 'checkbox' || el.type === 'radio') el.checked = false;
        else el.value = '';
        el.dispatchEvent(new Event('input', { bubbles: true }));
        render();
      });
      chips.appendChild(button);
    });
    panel.querySelector('.cpr-selection-empty').hidden = selection.length > 0;
    panel.querySelector('.cpr-selection-clear').hidden = selection.length === 0;
    panel.querySelector('.cpr-selection-footer .cpr-mobile-apply').textContent =
      selection.length ? `Toepassen (${selection.length})` : 'Toepassen';
    panel.querySelectorAll('.cc-filter:not(.cc-filter--sort)').forEach(detail => {
      const summary = detail.querySelector('summary');
      if (!summary) return;
      let badge = summary.querySelector('.cpr-selection-count');
      if (!badge) { badge = document.createElement('span'); badge.className = 'cpr-selection-count'; summary.appendChild(badge); }
      const count = selection.filter(el => detail.contains(el)).length;
      badge.textContent = count ? `(${count})` : '';
    });
  }
  function prepare() {
    if (panel.matches('.cc-filter--sort') || panel.querySelector('.cpr-selection-summary')) return;
    const summary = document.createElement('div');
    summary.className = 'cpr-selection-summary';
    summary.innerHTML = '<p class="cpr-selection-empty">Nog geen filters geselecteerd</p><div class="cpr-selection-chips"></div>';
    const header = panel.querySelector('.cc-filters__header,.cc-filter__header');
    if (header) header.after(summary); else panel.prepend(summary);
    const footer = document.createElement('div');
    footer.className = 'cpr-selection-footer';
    footer.innerHTML = '<button type="button" class="cpr-mobile-apply">Toepassen</button><button type="button" class="cpr-selection-clear">Alles wissen</button>';
    panel.appendChild(footer);
  }
  function close(cancel = true) {
    if (!panel) return;
    if (cancel && form?.isConnected) snapshot.forEach(([el, value, checked]) => { el.value = value; el.checked = checked; });
    panel.classList.remove('cpr-panel-open');
    panel.removeAttribute('role'); panel.removeAttribute('aria-modal'); panel.removeAttribute('aria-label');
    if (panel.matches('details')) panel.open = false;
    form.querySelectorAll('.cc-filter:not(.cc-filter--sort)').forEach(el => { el.open = false; el.classList.remove('is-open'); });
    document.body.style.overflow = previousOverflow;
    document.body.classList.remove('cpr-mobile-panel-open');
    opener?.setAttribute('aria-expanded', 'false');
    if (opener?.isConnected) opener.focus();
    panel = null; form = null;
  }
  function open(button, f, sorting) {
    close(); form = f; opener = button;
    panel = f.querySelector(sorting ? '.cc-filter--sort' : '.cc-filters');
    if (!panel) { form = null; return; }
    snapshot = inputs(f).map(el => [el, el.value, el.checked]);
    previousOverflow = document.body.style.overflow;
    if (sorting) panel.open = true;
    prepare();
    panel.classList.add('cpr-panel-open');
    panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', sorting ? 'Sorteren op' : 'Filter op');
    button.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('cpr-mobile-panel-open');
    render(); panel.querySelector('.js-close-filters')?.focus();
  }
  document.addEventListener('click', e => {
    if (!mobile.matches || !(e.target instanceof Element)) return;
    const f = e.target.closest('.cpr-collection-reference .cc-facet-filters');
    if (!f) return;
    const button = e.target.closest('button');
    if (button?.matches('.js-show-filters,.js-show-sort')) {
      e.preventDefault(); e.stopImmediatePropagation();
      open(button, f, button.matches('.js-show-sort')); return;
    }
    if (panel && button?.matches('.cpr-selection-clear')) {
      e.preventDefault(); e.stopImmediatePropagation();
      selected().forEach(el => { if (el.type === 'checkbox' || el.type === 'radio') el.checked = false; else el.value = ''; });
      render(); return;
    }
    if (button?.matches('.js-close-filters,.cc-filter-back-btn,.cpr-mobile-apply')) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (button.matches('.cc-filter-back-btn')) { button.closest('details').open = false; return; }
      const apply = button.matches('.cpr-mobile-apply');
      const target = f.querySelector('.cc-filters-container input') || f.querySelector('input');
      close(!apply);
      if (apply && target) {
        forwarding = true;
        try { target.dispatchEvent(new Event('input', { bubbles: true })); } finally { forwarding = false; }
      }
      return;
    }
    const summary = e.target.closest('.cc-filter__toggle');
    if (summary && panel) {
      e.preventDefault(); e.stopImmediatePropagation();
      const detail = summary.closest('details'), wasOpen = detail.open;
      f.querySelectorAll('.cc-filter:not(.cc-filter--sort)').forEach(el => el.open = false);
      detail.open = !wasOpen;
    }
    // Native clear links would apply immediately; keep changes pending instead.
    const clear = e.target.closest('.cc-filter-clear-btn');
    if (panel && clear) {
      e.preventDefault(); e.stopImmediatePropagation();
      const detail = clear.closest('.cc-filter');
      selected().filter(el => !detail || detail.contains(el)).forEach(el => {
        if (el.type === 'checkbox' || el.type === 'radio') el.checked = false; else el.value = '';
      });
      render();
    }
  }, true);
  for (const type of ['input', 'change']) document.addEventListener(type, e => {
    if (mobile.matches && panel && !forwarding && form?.contains(e.target)) {
      e.stopImmediatePropagation(); render();
    }
  }, true);
  document.addEventListener('keydown', e => {
    if (!panel) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    if (e.key === 'Tab') {
      const nodes = [...panel.querySelectorAll('button,a[href],input,summary')].filter(el => !el.disabled && !el.hidden && el.getClientRects().length);
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { e.preventDefault(); last?.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { e.preventDefault(); first?.focus(); }
    }
  });
  document.addEventListener('submit', e => {
    if (panel && e.target === form && mobile.matches) { e.preventDefault(); panel.querySelector('.cpr-mobile-apply')?.click(); }
  }, true);
  mobile.addEventListener('change', () => close());
  document.addEventListener('filters-applied', () => close(false));
  document.addEventListener('shopify:section:unload', () => close());
})();
